import e from "./_deburrLetter.js";
import o from "./toString.js";
var a = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, f = "\\u0300-\\u036f", u = "\\ufe20-\\ufe2f", m = "\\u20d0-\\u20ff", b = f + u + m, t = "[" + b + "]", x = RegExp(t, "g");
function p(r) {
  return r = o(r), r && r.replace(a, e).replace(x, "");
}
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/deburr.js
// module id = 1561
// module chunks = 67